import * as React from "react";
const SvgFiRrCompressAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-compress-alt_svg__a)">
      <path d="M7.293 2.09 5.4 3.984 1.707.292A1 1 0 0 0 .293 1.706L3.985 5.4 2.091 7.292A1 1 0 0 0 2.801 9h4.763A1.436 1.436 0 0 0 9 7.563V2.8a1 1 0 0 0-1.707-.709M20.015 18.6l1.894-1.894A1 1 0 0 0 21.2 15h-4.764A1.436 1.436 0 0 0 15 16.436V21.2a1 1 0 0 0 1.707.708l1.893-1.893 3.692 3.692a1 1 0 0 0 1.414-1.414zM16.436 9H21.2a1 1 0 0 0 .708-1.707L20.015 5.4l3.692-3.692A1 1 0 0 0 22.293.293L18.6 3.985 16.707 2.09A1 1 0 0 0 15 2.8v4.764A1.436 1.436 0 0 0 16.436 9M7.564 15H2.8a1 1 0 0 0-.708 1.707L3.985 18.6.293 22.293a1 1 0 1 0 1.414 1.414L5.4 20.015l1.894 1.894A1 1 0 0 0 9 21.2v-4.764A1.436 1.436 0 0 0 7.564 15" />
    </g>
    <defs>
      <clipPath id="fi-rr-compress-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCompressAlt;
